<template>
  <v-container>
    <div v-if="currentLocation.id">
      <h1 class="mb-3"> Edit {{ locationType.text }} Location</h1>
      <LocationForm ref="locationForm" :initialLocation="currentLocation" @save="save" @cancel="cancel"/>
    </div>
  </v-container>
</template>
<script>
import event, { Events } from '../../../event'
import LocationForm from '@/components/Locations/LocationForm'
import { LocationTypeOptions } from '@/js/LocationTypes'

export default {
  name: 'EditLocationView',
  components: { LocationForm },
  data: () => ({
    LocationTypeOptions,
    currentLocation: {},
    locationType: {}
  }),
  mounted () {
    // can be service or clinic location
    this.getCurrentLocation()
  },
  methods: {
    async save (updatedLocation) {
      this.currentLocation = updatedLocation
      const url = this.$store.getters['Organization/apiUrl'] + '/locations'
      this.currentLocation.location_type = this.locationType.value

      await window.axios.put(url + `/${this.currentLocation.id}`, this.currentLocation)
      this.$store.commit('Organization/' + this.locationType.api, [])

      await this.$router.push({ name: this.locationType.index })
      event.emit(Events.SUCCESS, this.locationType.text + ' Location was successfully updated')
    },
    getCurrentLocation () {
      this.$store.dispatch('Organization/getCurrentLocation', this.$route.params.locationId)
        .then(response => {
          this.currentLocation = response
          this.locationType = LocationTypeOptions.find(x => x.value === this.$route.params.locationType)
        })
    },
    cancel () {
      this.$router.push({ name: this.locationType.index })
    }
  }
}
</script>
